import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/_modules/credit/admin/users/delegation-of-authority/')(
  {
    loader: () => {
      throw redirect({ to: '/credit/admin/users/delegation-of-authority/single-no-deviation' })
    },
  },
)
